(function($) {

	function checkTables() {

		var $this;
		var cw = $("#content").width();

		$("#content").find("table").each(function() {

			var $wrapper, $wrapperIn;

			$this = $(this);
			$this.css("max-width", "none");

			var needs = $this.outerWidth() > cw;
			var is = $this.parent().is(".table-wrapper-in");

			if (needs && !is) {

				$this.wrap("<div class='table-wrapper-in'></div>");
				$wrapperIn = $this.parent();
				$wrapperIn.wrap("<div class='content-table-wrapper'></div>");
				$wrapper = $wrapperIn.parent();
				initScrollingSides($this, $wrapperIn, $wrapper);

			} else if (!needs && is) {

				$this.parent().unwrap();
				$this.unwrap();

			}

			$this.css("max-width", "");

		});		
	}

	function initScrollingSides($table, $wrapperIn, $wrapper) {
		$wrapperIn.scroll(function() {
			if ($wrapperIn.scrollLeft() > 0) {
				$wrapper.addClass("can-scroll-left");
			} else {
				$wrapper.removeClass("can-scroll-left");
			}
			if ($wrapperIn.scrollLeft() < $table.outerWidth() - $wrapper.width()) {
				$wrapper.addClass("can-scroll-right");
			} else {
				$wrapper.removeClass("can-scroll-right");	
			}
		}).trigger("scroll");
	}

	$(function() {
		checkTables();
		$(window).resize(checkTables);
	});

	/*
	$(window).resize(function() {
		checkTables();
	});
	*/


})(jQuery);